// DS: i3.5
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const ArrowLeft = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M6.722 12.5l7.778 7.778 1.945-1.944L10.61 12.5l5.834-5.833L14.5 4.722 6.722 12.5z"
    })));
};
ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;
